export const TEXTS = {
  MODAL_TITLE: 'Запрос отправлен',
  DESCRIPTION: 'Менеджер свяжется с вами в течение рабочего дня',
  SUCCESS_BUTTON: 'Хорошо',
};
